<template>
  <v-text-field
    :dense="dense"
    type="text"
    v-model="input"
    @input="onInput"
    :option="{ currency: 'IDR' }"
    :disabled="disabled"
    :label="label"
    required
  />
</template>

<script>
export default {
  name: 'CustomInput',
  props: ['value', 'dense', 'disabled', 'allowZero', 'label'],
  data() {
    return {
      input: this.value,
    };
  },
  watch: {
    value: {
      handler(v) {
        this.input = this.$oldMoneyFormat(v, false, this.allowZero);
      },
      deep: true,
    },
  },
  mounted() {
    this.input = this.$oldMoneyFormat(this.value, true, this.allowZero);
  },
  methods: {
    onInput() {
      let x = this.input.toString();
      this.$emit('input', x);
    },
  },
};
</script>
